import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import LoginForm from 'components/login-form';
import LoadingSpinner from 'components/loading-spinner';

import './style.css';

const LoginPage = ({ user, referrer }) => {
  if (user.logged) {
    return (
      <Redirect to={referrer} />
    );
  }

  return (
    <div className="l-login-page">
      <div className="products-header -single">
        <h1>Login</h1>
      </div>
      <div className="login-container">
        <div className="login-content">
          {(user.message && user.message !== '') && (
            <div className="error-message">
              <p>{user.message}</p>
            </div>
          )}
          {user.isLoading && <LoadingSpinner />}
          {!user.isLoading && <LoginForm />}
        </div>
      </div>
    </div>


  );
};

LoginPage.propTypes = {
  user: PropTypes.shape({
    isLoading: PropTypes.bool,
    message: PropTypes.string
  }).isRequired,
  referrer: PropTypes.string
};

LoginPage.defaultProps = {
  referrer: window.location.pathname
};

const mapStateToProps = state => ({
  user: state.authentication.user,
  referrer: state.loginRequest.location.pathname
});

export default connect(mapStateToProps)(LoginPage);




// WEBPACK FOOTER //
// ./src/pages/login/index.js